var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more-comment",on:{"click":_vm.clickItem}},[_vm._v(_vm._s(_vm.status == 0 ? '暂时还没有人评论' : _vm.status == 1 ? '查看更多评论' : '已经加载全部评论了'))])
}
var staticRenderFns = []

export { render, staticRenderFns }